// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pIWf","col":"styles_col__-nCuz"};